<script lang="ts" context="module">
	export const KEY_TILES = 'tiles';
</script>
<script lang="ts">
	import type { BrandLogo, LandingItemContext } from "$lib/def/landing";
	import type { Options } from '$lib/serv/vendor-integration/splide';

	import { getRestaurantExposed as _getRestaurantExposed } from "$lib/serv/restaurant";
	import { SPKEYS, getDB } from "$lib/serv/food-landing";
	import { LOCATION_PROPS } from "$lib/serv/locations";
	import { Vertical } from "$lib/def/verticals";
	import { fetch$ } from "$lib/serv/core/cache";
	import { merchantNameSuburbSlug } from "$lib/util/format";
	import { queryFrom } from "$lib/util/url";
	import { getContext } from "svelte";
	import { EMPTY, firstValueFrom, map, of, from, startWith } from "rxjs";
	
	import CarouselV3 from "$lib/ui/layout/CarouselV3.svelte";
  import Brand from "./Brand.svelte";
	
	export let endpoint: string | undefined;
	export let searchParams: {
		[k: string]: string;
	};

	const { base, cacheAge } = getContext('endpoints') as LandingItemContext;

	type Data = { brand_logos: BrandLogo[] };

	const vertical = searchParams.vertical ?? Vertical.Restaurant;

	$: cache = endpoint ? fetch$<Data>(new URL(base + endpoint), SPKEYS, { db: getDB(), msMaxCacheAge: cacheAge.medium }) : EMPTY;

	const options: Options = {
		perMove: 6,
	}

	async function getRestaurantExposed(id: number) {
		return await firstValueFrom(_getRestaurantExposed(id));
	}

	function getUrl(brand: BrandLogo) {
		if (brand.restaurant_ids[0].length === 1) return from(getRestaurantExposed(brand.restaurant_ids[0][0])).pipe(
			map((restaurant) =>
				queryFrom(searchParams).keep(...LOCATION_PROPS).set('vertical', vertical).toUrl(`/delivery/${vertical}/${merchantNameSuburbSlug(restaurant?.name, restaurant?.address?.suburb)}/${brand.restaurant_ids[0][0]}`)
			),
			startWith(''),
		);
		// we'll use 'tiles' as param to filter the restaurants instead of 'stack' because we cannot assume that the brand has a stack
		return of(queryFrom(searchParams).set(KEY_TILES, brand.restaurant_ids.flat().join(',')).toUrl());
	}
</script>

<!-- TODO: @Dan - Add options -->
<CarouselV3 cache={$cache} type="brands" {options} key={(payload: { brand_logos: BrandLogo[] }) => payload?.brand_logos}>
	{#snippet title()}
		<h3 class="title headline-m bold">Popular brands</h3>
	{/snippet}
	{#snippet children({ item, index })}
			<Brand brand={item} url$={getUrl(item)} {index}/>
	{/snippet}
</CarouselV3>
